var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('wallet-header', {
    attrs: {
      "walletData": _vm.walletData
    }
  }), _c('transactions-overview', {
    attrs: {
      "stats": _vm.overviewStats
    }
  }), _c('Transactions')], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }